import React from 'react';
import { isEmpty } from 'lodash';

import ListItem from '@material-ui/core/ListItem';
import Chip from '@material-ui/core/Chip';
import { getDecimalNumber } from '../../common/global';

import styles from './Item.module.scss';

export default class Item extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getSuitableForPersons(suitables) {
    let suitableComponents = [];
    if (suitables) {
      suitables.forEach(s => {
        let adults = s.adults || '';
        let children = s.children || '';

        suitableComponents.push(
          <div
            style={{
              marginBottom: '3px',
            }}
          >
            <Chip
              label={adults}
              style={{
                visibility: adults ? 'visible' : 'collapse',
                backgroundColor: 'black',
                borderColor: 'black',
                color: 'white',
                fontSize: '12px',
              }}
              className={styles.circle}
            />
            <Chip
              label={children}
              style={{
                visibility: children ? 'visible' : 'collapse',
                backgroundColor: 'white',
                borderColor: 'black',
                color: 'black',
                fontSize: '12px',
              }}
              className={styles.circle}
            />
          </div>
        );
      });
    }
    return suitableComponents;
  }

  render() {
    const { item, currencySymbol, notActive } = this.props;
    const suitables = item.suitables || [];
    const num = getDecimalNumber(item.price, 2);
    let cost = '';
    let costLabel = 'Cost';

    if (isNaN(num)) {
      cost = '';
      costLabel = '';
    } else {
      cost = currencySymbol + num;
    }

    if (isEmpty(item)) return <div />;

    const itemName = item.name || '';

    return (
      <ListItem className={styles.root} onClick={this.props.onClickRouteFunc}>
        <div className={`${styles.item} ${notActive ? styles.notActive : null}`}>
          <div className={styles.itemDetails}>
            <span className={styles.boldFont}>{itemName}</span>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {this.getSuitableForPersons(suitables)}
          </div>
          <div className={styles.largeColumn}>
            <span className={styles.boldFont}>{costLabel}</span>
            &nbsp;
            {cost}
          </div>
        </div>
      </ListItem>
    );
  }
}
